/**
 * Costanti centralizzate per il tema team sulla pergamena.
 * Elimina la duplicazione di getTeamColor/getTeamBadgeStyle sparsi nei componenti.
 */

export const TEAM_FACTION_NAMES: Record<string, string> = {
  GREEN: "Compagnia dell'Abilità",
  RED: 'Legione della Forza',
  BLUE: 'Ordine del Potere',
  YELLOW: 'Casa del Caos',
};

export const TEAM_SHORT_NAMES: Record<string, string> = {
  GREEN: 'Verde',
  RED: 'Rossa',
  BLUE: 'Blu',
  YELLOW: 'Gialla',
};

export const TEAM_PARCHMENT_BG: Record<string, string> = {
  GREEN: 'parchment-bg-green',
  RED: 'parchment-bg-red',
  BLUE: 'parchment-bg-blue',
  YELLOW: 'parchment-bg-yellow',
};

export const TEAM_BADGE_STYLES: Record<string, string> = {
  GREEN: 'bg-team-green-bg text-team-green border-team-green',
  RED: 'bg-team-red-bg text-team-red border-team-red',
  BLUE: 'bg-team-blue-bg text-team-blue border-team-blue',
  YELLOW: 'bg-team-yellow-bg text-team-yellow border-team-yellow',
};

export const TEAM_BUTTON_CLASS: Record<string, string> = {
  GREEN: 'btn-team-green',
  RED: 'btn-team-red',
  BLUE: 'btn-team-blue',
  YELLOW: 'btn-team-yellow',
};

export const TEAM_TEXT_COLOR: Record<string, string> = {
  GREEN: 'text-team-green',
  RED: 'text-team-red',
  BLUE: 'text-team-blue',
  YELLOW: 'text-team-yellow',
};

export const TEAM_ACCENT_COLOR: Record<string, string> = {
  GREEN: 'text-team-green-accent',
  RED: 'text-team-red-accent',
  BLUE: 'text-team-blue-accent',
  YELLOW: 'text-team-yellow-accent',
};

export const TEAM_BORDER_COLOR: Record<string, string> = {
  GREEN: 'border-team-green',
  RED: 'border-team-red',
  BLUE: 'border-team-blue',
  YELLOW: 'border-team-yellow',
};

export const TEAM_BG_FILL: Record<string, string> = {
  GREEN: 'bg-team-green',
  RED: 'bg-team-red',
  BLUE: 'bg-team-blue',
  YELLOW: 'bg-team-yellow',
};

export function getTeamColor(team: string): string {
  return TEAM_TEXT_COLOR[team.toUpperCase()] || 'text-ink';
}

export function getTeamButtonClass(team: string): string {
  return TEAM_BUTTON_CLASS[team.toUpperCase()] || 'btn-fantasy';
}

export function getTeamBadgeStyle(team: string): string {
  return TEAM_BADGE_STYLES[team.toUpperCase()] || 'bg-parchment-200 text-ink border-parchment-300';
}

export function getTeamFactionName(team: string): string {
  return TEAM_FACTION_NAMES[team.toUpperCase()] || 'Squadra';
}

export function getTeamParchmentBg(team: string): string {
  return TEAM_PARCHMENT_BG[team.toUpperCase()] || '';
}
